export const COMPANY = {
  fullName: "EREDI CAVALLO FRANCESCO S.r.l.",
  brand: "ECFCOSTRUZIONI srl",
  tagline: "Tecnologie Edili",
  founded: 1958,
  address: "Corso Garibaldi, 10 — 85050 Savoia di Lucania (PZ)",
  phone: "0971/711145",
  phoneHref: "tel:+390971711145",
  email: "eredicavallofrancescosrl@gmail.com",
  website: "www.eredicavallo.it",
  websiteHref: "https://www.eredicavallo.it",
  designedBy: { name: "Graficaltech.it", href: "https://www.graficaltech.it" },
};

export const IMG = (id, w = 1600) =>
  `https://images.unsplash.com/photo-${id}?crop=entropy&cs=srgb&fm=jpg&q=85&w=${w}&auto=format`;

export const IMAGES = {
  hero: IMG("1780415493102-9d9fbb669bf4", 2400),
  quarry: IMG("1782067170999-9cea25e8ae53"),
  mountainInfra: IMG("1770869717609-61e4a9c535ab"),
  ropeCliff: IMG("1694239887358-39f76320b337"),
  ropeAction: IMG("1734445559663-8c006d072c95"),
  scaffoldRest: IMG("1649320316177-775fe2d67ca3"),
  scaffoldSteel: IMG("1603239564387-c5b5ea6f635e"),
  drillNight: IMG("1776196463688-5f21c9632c75"),
  drillFence: IMG("1790039139973-338fab20e9b3"),
  drillUrban: IMG("1780415493102-9d9fbb669bf4"),
  slopeRock: IMG("1595274303136-9963bb2672bc"),
  slopePine: IMG("1605821316113-236ca6766164"),
  scaffoldLadder: IMG("1626471671222-9d89fe4c2668"),
  scaffoldMan: IMG("1504964670878-71b73cec0ce1"),
};

export const MISSION =
  "Offrire soluzioni edili sicure, efficienti e durature, contribuendo allo sviluppo del territorio e garantendo sempre la massima qualità delle opere realizzate.";

export const INNOVATION = {
  title: "L'innovazione che protegge",
  subtitle: "Messe in opera di Reti",
  text: "Con lo stesso spirito che ci ha guidato dal 1958, continuiamo a investire in competenze, tecnologie e innovazione per affrontare le sfide del settore edilizio moderno.",
};

export const SERVICES = [
  {
    id: "perforazioni",
    title: "Perforazioni",
    fullTitle: "Perforazioni e Carotaggi",
    tag: "OS21 III°-BIS",
    desc: "Sondaggi geognostici, perforazioni verticali e inclinate in qualsiasi matrice rocciosa, con attrezzature d'avanguardia per terreni ad alta complessità geotecnica.",
    image: IMAGES.drillNight,
  },
  {
    id: "opere-strutturali",
    title: "Opere Strutturali",
    fullTitle: "Opere Strutturali",
    tag: "Pali — Micropali — Tiranti — Chiodature",
    desc: "Consolidamenti con pali, micropali di grande diametro, tiranti d'ancoraggio attivi e passivi, chiodature e tiranti in roccia per fondazioni speciali.",
    image: IMAGES.drillFence,
  },
  {
    id: "ingegneria-naturalistica",
    title: "Ingegneria Naturalistica",
    fullTitle: "Opere di Ingegneria Naturalistica",
    tag: "OG8 II°",
    desc: "Stabilizzazione eco-compatibile dei versanti frana, muri in gabbioni drenanti, palificate in legname e pietrame, idrosemina ad alto spessore.",
    image: IMAGES.slopeRock,
  },
  {
    id: "barriere-paramassi",
    title: "Barriere Paramassi",
    fullTitle: "Barriere Paramassi e Paravalanghe",
    tag: "OS12-B III°",
    desc: "Fornitura e posa in opera di reti in acciaio ad alta resistenza, barriere paramassi certificate ad assorbimento d'energia elevato e paravalanghe montani.",
    image: IMAGES.mountainInfra,
  },
  {
    id: "tecniche-alpinistiche",
    title: "Tecniche Alpinistiche",
    fullTitle: "Interventi con Tecniche Alpinistiche in Cordata",
    tag: "Lavori su fune",
    desc: "Lavori su fune ad alto rischio su pareti rocciose verticali, viadotti e strutture inaccessibili, per mezzo di tecnici abilitati operanti in cordata.",
    image: IMAGES.ropeCliff,
  },
  {
    id: "opere-restauro",
    title: "Opere di Restauro",
    fullTitle: "Opere di Restauro e Consolidamento",
    tag: "OG2 II°",
    desc: "Interventi conservativi e restauro di strutture storiche, ponti antichi, cripte ed edifici vincolati, con malte speciali e cuciture armate.",
    image: IMAGES.scaffoldRest,
  },
];

export const MARQUEE_ITEMS = [
  "Perforazioni",
  "Opere Strutturali",
  "Pali e Micropali",
  "Tiranti e Chiodature",
  "Ingegneria Naturalistica",
  "Barriere Paramassi",
  "Tecniche Alpinistiche in Cordata",
  "Opere di Restauro",
];

export const SOA = [
  { code: "OG 1", level: "III°", title: "Edifici civili e industriali" },
  { code: "OG 2", level: "II°", title: "Restauro e manutenzione del patrimonio edilizio" },
  { code: "OG 3", level: "III-BIS", title: "Strade, autostrade, ponti, viadotti e ferrovie" },
  { code: "OG 6", level: "1°", title: "Acquedotti, gasdotti, oleodotti e opere di irrigazione" },
  { code: "OG 8", level: "II°", title: "Opere marittime e lavori di dragaggio" },
  { code: "OS 12-B", level: "III°", title: "Barriere stradali di sicurezza e paramassi" },
  { code: "OS 21", level: "III°-BIS", title: "Strutture speciali, perforazioni, pali e micropali" },
];

export const STRENGTHS = [
  "Esperienza pluridecennale nel settore",
  "Gestione familiare e attenzione al cliente",
  "Affidabilità e puntualità nelle consegne",
  "Capacità di adattarsi a ogni esigenza progettuale",
  "Elevati standard qualitativi",
];

export const STATS = [
  { value: "1958", label: "Anno di fondazione" },
  { value: "60+", label: "Anni di attività" },
  { value: "7", label: "Categorie SOA" },
  { value: "ISO 9001", label: "Qualità certificata" },
];

export const CAT_LABELS = {
  perforazioni: "Perforazioni",
  "opere-strutturali": "Opere Strutturali",
  versanti: "Versanti",
  "in-quota": "Opere in quota",
  restauri: "Restauri",
};

export const GALLERY_FILTERS = [
  { id: "tutte", label: "Tutte" },
  { id: "perforazioni", label: "Perforazioni" },
  { id: "opere-strutturali", label: "Opere Strutturali" },
  { id: "versanti", label: "Versanti" },
  { id: "in-quota", label: "Opere in quota" },
  { id: "restauri", label: "Restauri" },
];

export const GALLERY = [
  { id: "g1", image: IMAGES.drillNight, cat: "perforazioni", catLabel: "Perforazioni", title: "Impianto di perforazione in opera" },
  { id: "g2", image: IMAGES.drillFence, cat: "perforazioni", catLabel: "Perforazioni", title: "Attrezzature geotecniche di grosso calibro" },
  { id: "g3", image: IMAGES.drillUrban, cat: "perforazioni", catLabel: "Perforazioni", title: "Perforazioni in area urbana" },
  { id: "g4", image: IMAGES.quarry, cat: "perforazioni", catLabel: "Perforazioni", title: "Pianta di perforazione in cava" },
  { id: "g5", image: IMAGES.mountainInfra, cat: "versanti", catLabel: "Versanti", title: "Opere di sistemazione idraulica montana" },
  { id: "g6", image: IMAGES.slopeRock, cat: "versanti", catLabel: "Versanti", title: "Stabilizzazione di un versante roccioso" },
  { id: "g7", image: IMAGES.slopePine, cat: "versanti", catLabel: "Versanti", title: "Canalizzazioni e drenaggi in montagna" },
  { id: "g8", image: IMAGES.ropeCliff, cat: "in-quota", catLabel: "Opere in quota", title: "Tecnico alpinista su parete rocciosa" },
  { id: "g9", image: IMAGES.ropeAction, cat: "in-quota", catLabel: "Opere in quota", title: "Interventi in cordata su parete" },
  { id: "g10", image: IMAGES.scaffoldLadder, cat: "in-quota", catLabel: "Opere in quota", title: "Squadra al lavoro su impalcato" },
  { id: "g11", image: IMAGES.scaffoldRest, cat: "restauri", catLabel: "Restauri", title: "Restauro con ponteggio completo" },
  { id: "g12", image: IMAGES.scaffoldSteel, cat: "restauri", catLabel: "Restauri", title: "Struttura in restauro conservativo" },
  { id: "g13", image: IMAGES.scaffoldMan, cat: "restauri", catLabel: "Restauri", title: "Manutenzione del patrimonio edilizio" },
];

export const NAV_LINKS = [
  { to: "/", label: "Home" },
  { to: "/mission", label: "Mission" },
  { to: "/chi-siamo", label: "Chi Siamo" },
  { to: "/attivita-e-servizi", label: "Attività e Servizi" },
  { to: "/galleria", label: "Galleria" },
  { to: "/contatti", label: "Contatti" },
];

export const DEFAULT_CONTENT = {
  hero_subline:
    "Una tradizione familiare nel cantiere da oltre 60 anni: perforazioni, opere strutturali, ingegneria naturalistica e restauro, in tutta sicurezza.",
  hero_image: IMAGES.hero,
  intro_text:
    "Eredicavallo Francesco Srl è un'azienda storica nel settore dell'edilizia, fondata nel 1958 da Francesco Cavallo. Da oltre 60 anni operiamo con continuità, portando avanti una tradizione familiare che si è tramandata di generazione in generazione: dai figli fino agli attuali nipoti.",
  intro_image: IMAGES.quarry,
  mission_quote: MISSION,
  chi_siamo_p1:
    "Eredicavallo Francesco Srl è un'azienda storica nel settore dell'edilizia, fondata nel 1958 da Francesco Cavallo.",
  chi_siamo_p2:
    "Da oltre 60 anni operiamo con continuità, portando avanti una tradizione familiare che si è tramandata di generazione in generazione: dai figli fino agli attuali nipoti.",
  chi_siamo_p3:
    "La nostra azienda nasce dall'esperienza e dalla visione del fondatore, crescendo nel tempo grazie a competenza, affidabilità e dedizione al lavoro. Oggi rappresentiamo una realtà solida che unisce tradizione e innovazione, mantenendo gli stessi valori che ci contraddistinguono fin dall'inizio.",
  innovation_text: INNOVATION.text,
  service_image_perforazioni: IMAGES.drillNight,
  "service_image_opere-strutturali": IMAGES.drillFence,
  "service_image_ingegneria-naturalistica": IMAGES.slopeRock,
  "service_image_barriere-paramassi": IMAGES.mountainInfra,
  "service_image_tecniche-alpinistiche": IMAGES.ropeCliff,
  "service_image_opere-restauro": IMAGES.scaffoldRest,
};
